import styled from 'styled-components';

export const FieldGroupButton = styled.div`
  position: relative;
`;

export const SpinnerScope = styled.div`
  padding: 75px;
  text-align: center;
`;
